import React from 'react';
import { Play, Plus, Settings } from 'lucide-react';
import { Button } from '../ui/Button';

const AutomationBuilder: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Email Automations</h2>
          <p className="text-sm text-gray-600">Create and manage automated email sequences</p>
        </div>
        <Button className="flex items-center">
          <Plus className="h-4 w-4 mr-2" />
          New Automation
        </Button>
      </div>

      {/* Empty State */}
      <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
          <Settings className="h-6 w-6 text-primary" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">No automations yet</h3>
        <p className="text-gray-600 mb-6">
          Create your first automation to start sending targeted emails automatically
        </p>
        <Button className="flex items-center mx-auto">
          <Play className="h-4 w-4 mr-2" />
          Create First Automation
        </Button>
      </div>
    </div>
  );
};

export default AutomationBuilder;